import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum HHDisciplineEnum {
    "Nursing" = 1,
    "PT" = 2,
    "OT" = 3,
    "ST" = 4,
    "HHA" = 5,
    "MSW" = 6,
    "Dietician" = 7,
    "Orders" = 9
}

class HHDisciplineClass extends EnumWithDescription<HHDisciplineEnum> {
    public readonly enum = HHDisciplineEnum;
    public readonly enumName: string = "HHDisciplineEnum";
    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<HHDisciplineEnum>> = new Map([
        [
            "Nursing",
            {
                name: "Nursing",
                value: 1
            }
        ],
        [
            "PT",
            {
                name: "PT",
                value: 2
            }
        ],
        [
            "OT",
            {
                name: "OT",
                value: 3
            }
        ],
        [
            "ST",
            {
                name: "ST",
                value: 4
            }
        ],
        [
            "HHA",
            {
                name: "HHA",
                value: 5
            }
        ],
        [
            "MSW",
            {
                name: "MSW",
                value: 6
            }
        ],
        [
            "Dietician",
            {
                name: "Dietician",
                value: 7
            }
        ],
        [
            "Orders",
            {
                name: "Orders",
                value: 9
            }
        ]
    ]);
}

export const HHDiscipline = new HHDisciplineClass();
